<template>
    <section :id="component.identifier ? component.identifier : ''" class="mb-64" v-if="show">
        <div v-for="(quote, index) in translatedQuotes" :key="quote.id"
            class="site__color--brand site__font--display site__container pt-64 flex flex-col items-center">
            <div class="inline-flex items-center justify-center">
                <svg class="-mt-24 block fill-current w-24 lg:w-28 mr-8" width="46" height="36" transform="rotate(180)" enable-background="new 0 0 75.999 75.999" viewBox="0 0 75.999 75.999">
                    <path d="m14.579 5c-8.052 0-14.579 6.716-14.579 15 0 8.285 6.527 15 14.579 15 14.578 0 4.859 29-14.579 29v7c34.69 0 48.286-66 14.579-66zm42 0c-8.052 0-14.579 6.716-14.579 15 0 8.285 6.527 15 14.579 15 14.578 0 4.859 29-14.579 29v7c34.69 0 48.286-66 14.579-66z"/>
                </svg>
                 <p
                    class="flex justify-center text-center italic w-3/4 font-semibold"
                    v-html="translated(quote.content)"
                    :class="textSize"
                ></p>
                <svg class="-mt-24 block fill-current w-24 lg:w-28 ml-8" width="46" height="36" enable-background="new 0 0 75.999 75.999" viewBox="0 0 75.999 75.999">
                    <path d="m14.579 5c-8.052 0-14.579 6.716-14.579 15 0 8.285 6.527 15 14.579 15 14.578 0 4.859 29-14.579 29v7c34.69 0 48.286-66 14.579-66zm42 0c-8.052 0-14.579 6.716-14.579 15 0 8.285 6.527 15 14.579 15 14.578 0 4.859 29-14.579 29v7c34.69 0 48.286-66 14.579-66z"/>
                </svg>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from 'pinia';
import { useCommonStore } from '../../state/common';
import { useBrandingStore } from '../../state/branding'
import { responsive, runningInBrowser } from '../../helpers';

export default {
    props: {
        component: {
            required: true,
        }
    },
    data: function () {
        return {}
    },
    computed: {
        ...mapState(useCommonStore, ['locale']),
        ...mapState(useBrandingStore, ['preview']),
        show () {
            return runningInBrowser() || this.hasContent;
        },
        hasContent () {
            return this.translatedQuotes && !!this.translatedQuotes.length;
        },
        translatedQuotes: {
            get () {
                let quotes = [];
                for (let quote of this.component.quotes) {
                    if (this.hasTrans(quote)) {
                        quotes.push(quote);
                    }
                }

                return quotes;
            }
        },
        textSize () {
            return responsive(this.preview.type, 'text-heading-2 lg:text-heading-1');
        },
    },
    methods: {
        hasTrans (quote) {
            let content = this.translated(quote.content) ? this.translated(quote.content).trim() : null;

            return content && content !== '';
        }
    },
    mounted () {
        this.$emit('loaded');
    }
}
</script>

<style scoped>

</style>
